export default {
  showPhysicians: true,
  allowPhysicianRegistration: true,
  showRealtors: false,
  refinerProjectId: 'b8256080-5749-11f0-a862-a7db130db598',
  allowAIJobSearch: true,
}
